import {
    Button,
    Typography,
    Grid,
    TextField,
    Container,
    Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Phone, PhoneDisabled, Assignment } from "@material-ui/icons";

import { SocketContext } from "../SocketContext";
import { useContext, useState } from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    gridContainer: {
        width: "100%",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
    },
    container: {
        width: "600px",
        margin: "35px 0",
        padding: 0,
        [theme.breakpoints.down("xs")]: {
            width: "80%",
        },
    },
    margin: {
        marginTop: 20,
    },
    padding: {
        padding: 20,
    },
    paper: {
        padding: "10px 20px",
        border: "2px solid black",
    },
}));

const Options = ({ children }) => {
    const classes = useStyles();
    const { me, name, setName, callAccepted, callUser, callEnded, leaveCall } =
        useContext(SocketContext);
    const [idToCall, setIdToCall] = useState("");
    return (
        <Container className={classes.container}>
            <Paper elevation={10} className={classes.paper}>
                <form className={classes.root} noValidate autoComplete="off">
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={12} md={6} className={classes.padding}>
                            <Typography variant="h6" gutterBottom>
                                Account info
                            </Typography>
                            <TextField
                                fullWidth
                                label="name"
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                            />
                            <CopyToClipboard
                                text={me}
                                className={classes.margin}
                            >
                                <Button
                                    startIcon={<Assignment fontSize="large" />}
                                    variant="contained"
                                    fullWidth
                                    color="primary"
                                >
                                    Copy Your Id
                                </Button>
                            </CopyToClipboard>
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.padding}>
                            <Typography variant="h6" gutterBottom>
                                Make call
                            </Typography>
                            <TextField
                                fullWidth
                                label="Id to call"
                                value={idToCall}
                                onChange={(e) => {
                                    setIdToCall(e.target.value);
                                }}
                            />
                            {callAccepted && !callEnded ? (
                                <Button
                                    fullwidth='true'
                                    variant="contained"
                                    color="secondary"
                                    onClick={leaveCall}
                                    className={classes.margin}
                                    startIcon={
                                        <PhoneDisabled fontSize="large" />
                                    }
                                >
                                    Hangup
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => callUser(idToCall)}
                                    className={classes.margin}
                                    startIcon={<Phone fontSize="large" />}
                                    fullwidth='true'
                                >
                                    call
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </form>
            {children}
            </Paper>
        </Container>
    );
};

export default Options;
